import { useTranslation } from 'react-i18next';
import { CraftAssetDownload } from '#pie/components/craft-asset-download/CraftAssetDownload';
import type { CreateDataRequestDto } from '#pie/internal/api/pie-bff';
import { DataLevel } from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

const { ConditionalField, FormFile } = typedFormFields<CreateDataRequestDto>();

export const PartitionLevelAddress = () => {
  // Stuur lijst met adres(sen) mee in Excel formaat
  const { t } = useTranslation('dataRequest');

  return (
    <ConditionalField
      field="partitionFile"
      condition={(formValue) =>
        formValue('partitionLevel') === DataLevel.Address
      }
    >
      <FormFile
        label={t('address_level_file')}
        name="partitionFile"
        rules={{ required: true }}
      />
      <CraftAssetDownload title="Aanleveren clusters voorbeeldbestand" />
    </ConditionalField>
  );
};
